import React from "react";
import { Flex, Image } from "rebass/styled-components";
import styled from "styled-components";
import { useRecoilState } from "recoil";

import { Button } from "../../../../../Components/Button";
import { ReactComponent as RemixBadge } from "../../../../../../assets/images/badges/remix-icon.svg";
import { StudioSession } from "../../../../../State/studioSession";

export const RemixHeader = ({
  remixData,
  remixedCards,
  postRemix,
  hidden,
}: any) => {
  const [studioSession] = useRecoilState(StudioSession);
  if (!remixData.moment) {
    return null;
  }
  if (hidden) return <></>;
  return (
    <StyledPage justifyContent="space-between">
      <StyledRemix
        flexDirection={["column", "column", "column", "column"]}
        justifyContent="space-between"
      >
        <Flex
          flexDirection={["column"]}
          justifyContent="space-between"
          mx={2}
          my={2}
        >
          <StyledButton
            mt={4}
            mb={1}
            disabled={!remixedCards.length && !studioSession.useSignature}
            classification="remixFeed"
            alignSelf={"center"}
            onClick={postRemix}
          >
            <StyledIcon />
            Remix Clip
          </StyledButton>
        </Flex>
      </StyledRemix>
    </StyledPage>
  );
};

const StyledIcon = styled(RemixBadge)`
  margin-right: 8px;
  height: 18px;
  width: 18px;
  flex-shrink: 0;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-right: 5px;
    height: 14px;
    width: 14px;
  }
`;

// const Description = styled(Flex)`
//   margin-top: 30px;
//   height: 10px;
//   font-size: 0.75em;
// `;

const ClipImage = styled(Image)`
  position: absolute;
  top: -75px;
  left: 25px;
  width: 160px;
  border-radius: 4px;
  margin-right: 10px;
  border: 1px solid rgba(249, 83, 112, 1);
  box-shadow: 0px 6px 10px rgba(12, 13, 13, 1);
`;

const StyledCopy = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 1em;
  wodth: 100%;
`;

const StyledDescription = styled(Flex)`
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledRemix = styled(Flex)`
  position: fixed;
  bottom: 0;
  margin: auto;
  width: 100%;
  right: 0;
  z-index: 8;
  padding: 15px;
  border-radius: 0;
  border-top: 2px solid;
  border-color: ${(props: any) => props.theme.colors.alert};
  background-color: ${(props: any) => props.theme.colors.midnight};
  color: ${(props: any) => props.theme.colors.ice};

  @supports (backdrop-filter: blur(70px)) {
    & {
      background-color: #130c18b3;
      backdrop-filter: blur(70px);
    }
  }
`;

const StyledPage = styled(Flex)`
  justify-content: space-between;
  z-index: 10000;
`;

const StyledButton = styled(Button)`
  height: 60px;
  font-size: 16px;
  padding-left: 35px;
  padding-right: 35px;
  flex-basis: content;
  align-items: center;
  line-height: 1.9;
  ${({ disabled }) =>
    disabled &&
    `
    opacity: .75;
    border-color: transparent;
  `}
`;
